module.exports = __webpack_public_path__ + "144b1189fbed011417934947e4620025.png";